<template>
 <l-layout :layout="['xs12']" bottom-space>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card>
          <l-data-table
          :headers="list_header"
          :get-data-func="getReviewList"
          :filter-items="filterItems"
          @click:row="getDetails($event.item,'review')"
          clickable
          hide-title-search
          ref="vehicleReviewList">
            <template slot="title">
              <span class="pl-2 pr-4">待审核车辆列表</span>
              <v-radio-group mandatory row v-model="vehicleType">
                <v-radio :value="'per_ve'" label="校内用户车辆"></v-radio>
                <v-radio :value="'org_ve'" label="校内单位公车"></v-radio>
                <v-radio :value="'coo_ve'" label="合作用户车辆"></v-radio>
              </v-radio-group>
            </template>
            <template slot="filter:driver">
              <v-autocomplete
                :items="filter.userSelect"
                v-model="filterItems[4].value"
                v-on:keyup="getUsers"
                label="车主工号"
                clearable
                hide-details
                hide-selected
                item-text="loginId"
                item-value="id"
                prepend-icon="$vuetify.icons.person"
              >
                <template slot="no-data">
                  <v-alert :value="true" color="error">
                    暂无该用户信息
                  </v-alert>
                </template>
                <template slot="item" slot-scope="props">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-flex row align-center justify-between>
                        <span>{{props.item.name}}</span>
                      </v-flex>
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <span class="grey--text caption text-xs-right">{{props.item.loginId}}</span>
                  </v-list-tile-action>
                </template>
              </v-autocomplete>
            </template>
          </l-data-table>
        </v-card>
        <v-layout justify-center>
          <v-btn flat color="primary" v-if="!showCompleted" @click="showCompleted=!showCompleted">显示已审核完成列表</v-btn>
          <v-btn flat color="primary" v-if="showCompleted" @click="showCompleted=!showCompleted">隐藏已审核完成列表</v-btn>
        </v-layout>
        <v-card class = mt-2 v-if="showCompleted">
          <l-data-table
            :headers="list_header_2"
            :get-data-func="getCompletedList"
            :filter-items="filterItems_2"
            @click:row="getDetails($event.item,'readonly')"
            clickable
            hide-title-search
            ref="vehicleCompletedList">
            <template slot="title">
              <span class="pl-2 pr-4">审核完成车辆列表</span>
              <v-radio-group mandatory row v-model="vehicleType_2">
                <v-radio :value="'per_ve'" label="校内用户车辆"></v-radio>
                <v-radio :value="'org_ve'" label="校内单位公车"></v-radio>
                <v-radio :value="'coo_ve'" label="合作用户车辆"></v-radio>
              </v-radio-group>
            </template>
            <template slot="filter:driver">
              <v-autocomplete
                :items="filter.userSelect"
                v-model="filterItems_2[5].value"
                v-on:keyup="getUsers"
                label="车主工号"
                clearable
                hide-details
                hide-selected
                item-text="loginId"
                item-value="id"
                prepend-icon="$vuetify.icons.person"
              >
                <template slot="no-data">
                  <v-alert :value="true" color="error">
                    暂无该用户组信息
                  </v-alert>
                </template>
                <template slot="item" slot-scope="props">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-flex row align-center justify-between>
                        <span>{{props.item.name}}</span>
                      </v-flex>
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <span class="grey--text caption text-xs-right">{{props.item.loginId}}</span>
                  </v-list-tile-action>
                </template>
              </v-autocomplete>
            </template>
            <template slot="row-action" slot-scope="{item}">
              <td @click.stop class="px-0 mx-0 text-xs-center">
                <v-tooltip left>
                  <v-btn :disabled="item.status==='2'" @click="deleteVehicleConfirm(item)" slot="activator" icon>
                    <v-icon small>$vuetify.icons.delete</v-icon>
                  </v-btn>
                  <span>删除车辆</span>
                </v-tooltip>
              </td>
            </template>
          </l-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog width="500" v-model="deleteForce">
      <v-layout column>
        <v-card class="pa-3">
          <v-card-title>
            <h4>
              {{deleteFailMsg}}
            </h4>
          </v-card-title>
          <v-layout justify-center>
            <p>
              是否强制删除?
            </p>
          </v-layout>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn class="error" @click="deleteVehicle(curVehicle,true)" :loading="deleteLoading">删除</v-btn>
              <v-btn @click="deleteForce=false">取消</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-dialog>
  </l-layout>
</template>
<script>
import LDataTable from '../../ladmin/components/LDataTable/LDataTable'
import {time} from '../../ladmin/utils/time'
const reviewStatus = {
  '0': '等待审核',
  '1': '审核通过',
  '2': '审核拒绝'
}
export default {
  name: 'vehicleReviewList',
  components: {LDataTable},
  data () {
    return {
      showCompleted: false,
      list_header: [
        {text: '车辆号牌', value: 'plateNumber', align: 'left', sortable: false},
        {text: '车主姓名', value: 'name', align: 'left', sortable: false},
        {text: '联系方式', value: 'phone', align: 'left', sortable: false},
        {text: '提交时间', value: 'creationTime', align: 'left', f: (v) => time.stringify(v)},
      ],
      list_header_2: [
        {text: '车辆号牌', value: 'plateNumber', align: 'left', sortable: false},
        {text: '车主姓名', value: 'name', align: 'left', sortable: false},
        {text: '联系方式', value: 'phone', align: 'left', sortable: false},
        {text: '用户到期时间', value: 'edTime', align: 'left', f: (v) => (v === '' ? 'N/A' : v.substr(0, 4) + '-' + v.substr(4, 2) + '-' + v.substr(5, 2))},
        {text: '提交时间', value: 'creationTime', align: 'left', f: (v) => time.stringify(v)},
        {text: '完成时间', value: 'lastUpdateTime', align: 'left', f: (v) => time.stringify(v)},
        {text: '审核结果', value: 'status', align: 'left', f: (v) => (reviewStatus[v + ''])},
        {text: ' ', value: '', align: 'left'},
      ],
      vehicleType: 'per_ve',
      vehicleType_2: 'per_ve',
      filter: {
        userSelect: [],
      },
      filterItems: [
        {
          key: 'creationTime',
          value: {},
          label: '登记时间',
          type: 'duration',
          layout: ['xs12', 'sm4'],
          f: v => v ? [time.toTimeStamp(v.startDatetime) || 0, time.toTimeStamp(v.endDatetime) || 9999999999999] : [0, 9999999999999],
          range: true
        },
        {
          key: 'lastUpdateTime',
          value: {},
          label: '审核完成时间',
          type: 'duration',
          layout: ['xs12', 'sm4'],
          f: v => v ? [time.toTimeStamp(v.startDatetime) || 0, time.toTimeStamp(v.endDatetime) || 9999999999999] : [0, 9999999999999],
          range: true,
        },
        {
          prependIcon: '$vuetify.icons.car',
          key: 'plateNumber',
          value: '',
          label: '车牌号码',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
        {
          prependIcon: '$vuetify.icons.phone',
          key: 'phone',
          value: '',
          label: '电话号码',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
        {
          prependIcon: '',
          key: 'driver',
          value: '',
          label: '车主姓名',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
      ],
      filterItems_2: [
        {
          key: 'creationTime',
          value: {},
          label: '登记时间',
          type: 'duration',
          layout: ['xs12', 'sm4'],
          f: v => v ? [time.toTimeStamp(v.startDatetime) || 0, time.toTimeStamp(v.endDatetime) || 9999999999999] : [0, 9999999999999],
          range: true
        },
        {
          key: 'lastUpdateTime',
          value: {},
          label: '审核完成时间',
          type: 'duration',
          layout: ['xs12', 'sm4'],
          f: v => v ? [time.toTimeStamp(v.startDatetime) || 0, time.toTimeStamp(v.endDatetime) || 9999999999999] : [0, 9999999999999],
          range: true,
        },
        {
          prependIcon: '$vuetify.icons.car',
          key: 'plateNumber',
          value: '',
          label: '车牌号码',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
        {
          prependIcon: '$vuetify.icons.phone',
          key: 'phone',
          value: '',
          label: '电话号码',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
        {
          prependIcon: '$vuetify.icons.folder',
          key: 'status',
          value: '',
          label: '审核结果',
          type: 'select',
          layout: ['xs12', 'sm4'],
          items: [{
            value: '1',
            text: '审核通过'
          },
          {
            value: '2',
            text: '审核拒绝'
          },
          {
            value: '0',
            text: '等待审核'
          }],
        },
        {
          prependIcon: '',
          key: 'driver',
          value: '',
          label: '车主姓名',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
      ],
      deleteForce:false,
      deleteFailMsg:"",
      curVehicle:{},
      deleteLoading:false
    }
  },
  methods: {
    async getReviewList ({pagination, sortStack, filterItems = [], search}) {
      // console.log(filterItems)
      let searchParam = {
        'searchParam': {
          'creationTime': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': (typeof filterItems[0].value.startDatetime === 'undefined') ? 9999999999999 : time.toTimeStamp(filterItems[0].value.endDatetime),
                'operator': 'LTE',
              },
              {
                'keyword': (typeof filterItems[0].value.endDatetime === 'undefined') ? 0 : time.toTimeStamp(filterItems[0].value.startDatetime),
                'operator': 'GTE',
              }
            ]
          },
          'lastUpdateTime': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': (typeof filterItems[1].value.startDatetime === 'undefined') ? 9999999999999 : time.toTimeStamp(filterItems[1].value.endDatetime),
                'operator': 'LTE',
              },
              {
                'keyword': (typeof filterItems[1].value.endDatetime === 'undefined') ? 0 : time.toTimeStamp(filterItems[1].value.startDatetime),
                'operator': 'GTE',
              }
            ]
          },
          'plateNumber': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': filterItems[2].value,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          },
          'phone': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': filterItems[3].value,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          },
          'status': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': '0',
                'operator': 'LIKE',
                'matchType': 'NONE'
              }
            ]
          },
          'checkType': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': this.vehicleType,
                'operator': 'LIKE',
                'matchType': 'NONE'
              }
            ]
          },
          'userId': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': filterItems[4].value,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          },
        }
      }
      let res = await this.$store.dispatch('vehicleRegister/getVehicleList', {searchParam: searchParam, pagination: pagination})
      console.log(res)
      if (res.data.status === 1) {
        let items = []
        for (let i = 0; i < res.data.data.content.length; i++) {
          let item = res.data.data.content[i]
          let obj = {
            name: item.user.name,
            plateNumber: item.vehicle.plateNumber,
            creationTime: item.vehicle.creationTime,
            phone: item.vehicle.phone,
            item: item
          }
          items.push(obj)
        }
        return {items: items, amount: res.data.data.totalElements}
      }
      else {
        this.$L.alert('error', {message: '查询失败，原因:' + res.data.msg})
      }
    },
    async getCompletedList ({pagination, sortStack, filterItems = [], search}) {
      // console.log(filterItems)
      let searchParam = {
        'searchParam': {
          'creationTime': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': (typeof filterItems[0].value.startDatetime === 'undefined') ? 9999999999999 : time.toTimeStamp(filterItems[0].value.endDatetime),
                'operator': 'LTE',
              },
              {
                'keyword': (typeof filterItems[0].value.endDatetime === 'undefined') ? 0 : time.toTimeStamp(filterItems[0].value.startDatetime),
                'operator': 'GTE',
              }
            ]
          },
          'lastUpdateTime': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': (typeof filterItems[1].value.startDatetime === 'undefined') ? 9999999999999 : time.toTimeStamp(filterItems[1].value.endDatetime),
                'operator': 'LTE',
              },
              {
                'keyword': (typeof filterItems[1].value.endDatetime === 'undefined') ? 0 : time.toTimeStamp(filterItems[1].value.startDatetime),
                'operator': 'GTE',
              }
            ]
          },
          'plateNumber': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': filterItems[2].value,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          },
          'phone': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': filterItems[3].value,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          },
          'status': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': (filterItems[4].value === '') ? '1,2' : filterItems[4].value,
                'operator': 'IN',
                'matchType': 'NONE'
              }
            ]
          },
          'checkType': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': this.vehicleType_2,
                'operator': 'LIKE',
                'matchType': 'NONE'
              }
            ]
          },
          'userId': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': filterItems[5].value,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          },
        }
      }
      let res = await this.$store.dispatch('vehicleRegister/getVehicleList', {searchParam: searchParam, pagination: pagination})
      // console.log(res)
      if (res.data.status === 1) {
        let items = []
        for (let i = 0; i < res.data.data.content.length; i++) {
          let item = res.data.data.content[i]
          let obj = {
            name: (item.user === null) ? '' : item.user.name,
            plateNumber: item.vehicle.plateNumber,
            creationTime: item.vehicle.creationTime,
            lastUpdateTime: item.vehicle.lastUpdateTime,
            edTime: (item.user === null) ? '' : (item.user.extend === null) ? '' : (JSON.parse(item.user.extend).edtime === undefined) ? '' : JSON.parse(item.user.extend).edtime,
            phone: item.vehicle.phone,
            item: item,
            status: item.vehicle.status
          }
          console.log(obj)
          items.push(obj)
        }
        return {items: items, amount: res.data.data.totalElements}
      }
      else {
        this.$L.alert('error', {message: '查询失败，原因:' + res.data.msg})
      }
    },
    getDetails (item, status) {
      // console.log(item)
      this.$router.push({
        name: 'vehicleDetailContentBox',
        query: {
          id: item.item.vehicle.id,
          status: status
        },
        params: {
          item: item
        }
      })
    },
    async getUsers (param) {
      let search = (param === undefined) ? '' : param.target.value + ''
      let pagination = {page: 0, rowsPerPage: 10}
      let searchParam = {
        'searchParam': {
          'loginId': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': search,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getUsers', {param: searchParam, pagination: pagination})
      if (res.data.status === 1) {
        this.filter.userSelect = res.data.data.content
        console.log(this.filter.userSelect)
      }
      else {
        this.filter.userSelect = []
      }
    },
    async deleteVehicleConfirm (item) {
      let {res, close} = await this.$L.confirm({
        title: '删除确认',
        text: '是否删除该车辆，车牌：' + item.plateNumber
      })
      if (res) {
        try {
          this.deleteVehicle(item,false)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteVehicle (items,status) {
      let ids = []
      ids.push(items.item.vehicle.id)
      this.deleteLoading = true
      let res = await this.$store.dispatch('vehicleRegister/deleteVehicles', {ids:ids,status:status})
      this.deleteLoading = false
      if (res.data.status === 1) {
        this.$L.alert('success', {message: '删除成功'})
        this.deleteForce = false
        this.curVehicle = {}
        this.$refs.vehicleCompletedList.refresh()
      }
      else {
        this.deleteFailMsg = '删除失败，原因:' + res.data.msg
        this.curVehicle = items
        this.deleteForce = true
      }
    }
  },
  watch: {
    vehicleType () {
      this.$refs.vehicleReviewList.refresh()
    },
    vehicleType_2 () {
      this.$refs.vehicleCompletedList.refresh()
    }
  }
}
</script>
<style></style>
